import type {FC} from 'react';
import MenuList from './components/MenuList.tsx';
import styled from 'styled-components';
import HomeIcon from './components/HomeIcon.tsx';
import Weather from './components/Weather.tsx';

const MenuWrapper = styled.div`
    grid-area: 1 / 2 / 2 / 9;
    background-color: #242426;
    padding: 1rem 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
    border-radius: 30px;
`;

const LeftMenu: FC = () => {
    return (
        <>
            <HomeIcon />
            <MenuWrapper>
                <MenuList />
                <Weather />
            </MenuWrapper>
        </>
    );
};

export default LeftMenu;
